<template>
    <div class="display-1 font-weight-light" :class="{ 'text-center': textCenter }">{{ text }}</div>
</template>

<script>
    export default {
        name: "PageHeading",
        props: {
            text: {
                required: true,
                type: String
            },
            textCenter: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>